<header id="header" [ngClass]="{ 'header-admin': isAdmin, 'header-triagist': isTriagist, 'header-super-user': isSuperUser }">
  <div class="d-flex w-100 gap-5 align-items-center justify-content-between">
    <h1>{{ featureTitleKey$ | async | translate }}</h1>
    <div class="d-flex ">
      <div class="preferences-container">
        <div class="d-flex flex-column gap-0 me-1">
          <p class="full-name-paragraph mb-0"> {{ (user$ | async) | fullName }}</p>
          <p class="mb-0 role-paragraph"> {{ (user$ | async) | userRole | translate }}</p>
        </div>
        @if (!isAdmin) {
          <a routerLink="/inbox" [routerLinkActive]="['active']" [class.has-unreaded-notifications]="hasUnreadConversations$ | async">
            <i-tabler name="mail" class="icon"></i-tabler>
          </a>
        }
        @if (!isAdmin) {
          <div class="divider"></div>
        }
        <a routerLink="/notifications" [routerLinkActive]="['active']">
          <i-tabler name="bell" class="icon"></i-tabler>
        </a>
        <div class="divider d-md-none"></div>
        @if (showSidebar) {
          <div class="d-md-none">
            @if (collapsed) {
              <button type="button" class="btn btn-link btn-link-primary btn-lg px-2"
                (click)="toggle()"
                >
                <div class="d-flex justify-content-center align-items-center">
                  <i-tabler name="menu-2" class="icon"></i-tabler>
                </div>
              </button>
            }
            @if (showSidebar) {
              <div class="sidebar-container" cdkTrapFocus>
                @if (!collapsed) {
                  <button type="button" class="btn btn-link btn-link-primary btn-lg px-2" (click)="toggle()"
                    >
                    <div class="d-flex justify-content-center align-items-center">
                      <i-tabler name="x" class="icon"></i-tabler>
                    </div>
                  </button>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</header>
<div class="sidebar-position d-md-none">
  <div class="sidebar" [collapse]="collapsed" [isAnimated]="true">
    <div class="container px-0 pt-3">
      <div class="sidebar-scrollable-view pr-2">
        <app-side-menu></app-side-menu>
      </div>
    </div>
  </div>
</div>

